export enum OrbitPauseStep {
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  PAUSED,
  INSUFFICIENT_GAS,
  UNKNOWN_ERROR,
  DEADLINE_EXCEEDED,
  REJECTED_BY_THE_USER,
}
